module.exports = __webpack_public_path__ + "images/unboxing_videos/cover_list_view-161af5ee1a2c7ba93373494fb1334b39.png";